import { useCallback, useEffect, useState, Fragment } from "react";
import LoadingCM from "components/shared/Loading";
import { StyledCardContent, StyledTypographyContent } from "./Privacy.style";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import useHttp from "hooks/use-http";
import { getPrivacyRequest } from "api/requests";
import Container from "@mui/material/Container";
import MenuCM from "components/shared/menu";
import FooterCM from "components/shared/footer";
import ContactCM from "components/contactus";
import parse from "html-react-parser";
import {Helmet} from "react-helmet";

export default function Privacy() {
  const { request, loading } = useHttp();
  const [text, setText] = useState("");

  const getContent = useCallback(async () => {
    let res = await request({
      url: getPrivacyRequest,
      values: {},
    });
    setText(res);
  }, [request]);

  useEffect(() => {
    getContent();
  }, [getContent]);

  return (
    <div>
      <Helmet>
        <title>حریم خصوصی - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <MenuCM pageTitle="حریم خصوصی" />
          <Container>
            <Card
              sx={{
                marginTop: "30px",
                marginBottom: "30px",
                borderRadius: "15px",
              }}
            >
              <StyledCardContent>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "21px",
                  }}
                >
                  حریم خصوصی
                </Typography>
              </StyledCardContent>

              <CardContent>
                <StyledTypographyContent
                  variant="body2"
                  color="text.secondary"
                  sx={{ textAlign: "justify" }}
                >
                  {text && parse(text?.text)}
                </StyledTypographyContent>
              </CardContent>
            </Card>
          </Container>
          <ContactCM All />
          <FooterCM />
        </Fragment>
      )}
    </div>
  );
}
